const types = {
    SET_LIST_EXCHANGE_RATES: '[EXCHANGE_RATES] SET LIST',
    SET_VIEW_EXCHANGE_RATES: '[EXCHANGE_RATES] SET VIEW'
}

export {
    types
}